module.exports = __webpack_public_path__ + "media/images/area-badges/green-manufacturing-249faad31985bec2a7d07c584b4d29f6.svg";